import { lazy } from 'react';

import { MinervaRoute } from 'src/utils/router';

import { calendarStore } from './store';

export const CalendarRoute: MinervaRoute<'calendar'> = {
  name: 'calendar',
  path: '/calendar',
  comp: () => lazy(() => import('./index')),

  activate: async _ => {
    await calendarStore.calendar.getCalendarActivities();
  },
  deactivate: async _ => {
    calendarStore.calendar.resetStore();
  },
};
